import React from 'react';
import { ShieldX, LogOut, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface BannedUserModalProps {
  reason?: string;
  onLogout: () => void;
  onRetry?: () => void;
  verificationError?: boolean;
}

export function BannedUserModal({ reason, onLogout, onRetry, verificationError = false }: BannedUserModalProps) {
  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-background"
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <div className="flex flex-col items-center justify-center text-center p-8 max-w-md mx-auto">
        <div className="w-24 h-24 rounded-full bg-destructive/20 flex items-center justify-center mb-6">
          <ShieldX className="w-12 h-12 text-destructive" />
        </div>
        
        <h1 className="text-3xl font-bold text-foreground mb-3">
          {verificationError ? 'Não foi possível validar seu acesso' : 'Acesso indisponível'}
        </h1>
        
        <p className="text-muted-foreground text-lg mb-6">
          {verificationError
            ? 'O Forja Hub bloqueou a entrada por segurança porque o Cérebro não confirmou sua autorização.'
            : 'O Cérebro não encontrou um acesso ativo para esta conta.'}
        </p>
        
        {reason && (
          <div className="w-full bg-muted/50 rounded-lg p-4 mb-6 border border-border">
            <p className="text-sm text-muted-foreground mb-1">Motivo:</p>
            <p className="text-foreground">{reason}</p>
          </div>
        )}
        
        <p className="text-sm text-muted-foreground mb-8">
          Se você acredita que isso foi um erro, entre em contato com o suporte.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3">
          {onRetry && (
            <Button onClick={onRetry} className="gap-2">
              <RefreshCw className="w-4 h-4" />
              Tentar novamente
            </Button>
          )}
          <Button onClick={onLogout} variant="outline" className="gap-2">
            <LogOut className="w-4 h-4" />
            Sair do Sistema
          </Button>
        </div>
      </div>
    </div>
  );
}
